import { render, staticRenderFns } from "./ViewDockingStation.vue?vue&type=template&id=4a320f46&lang=pug&"
import script from "./ViewDockingStation.vue?vue&type=script&lang=js&"
export * from "./ViewDockingStation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports